import React, { useEffect } from "react"
import normalize from "normalize-path"
import { SocialShare } from "../social/SocialShare"
import { PostEntryContent } from "./PostEntryContent"
import { PostEntryInfo } from "./PostEntryInfo"
import { PostEntryMedia } from "./PostEntryMedia"
import { PostEntryMeta } from "./PostEntryMeta"
import { PostEntryTitle } from "./PostEntryTitle"
import { PrevNextPostNavigation } from "./PrevNextPostNavigation"
import useDarkMode from "use-dark-mode"
import AdContainer from "../AdContainer"

export const PostEntry = ({
  isFirst = false,
  post,
  ctx,
  location,
  className = "",
  ...props
}) => {
  const media = post.featuredImage
    ? post.featuredImage.node.localFile?.childImageSharp?.original.src
    : null

  const { pageTemplate, skipTitle } = post.headlesswp

  const { value: darkModeValue } = useDarkMode()

  // Attach script for utteranc.es on componentDidMount
  useEffect(() => {
    let script = document.createElement("script")
    let anchor = document.getElementById("inject-comments-for-uterances")

    anchor.innerHTML = ""

    script.setAttribute("src", "https://utteranc.es/client.js")
    script.setAttribute("crossorigin", "anonymous")
    script.setAttribute("async", true)
    script.setAttribute("repo", "Dunebook/codesource")
    script.setAttribute("issue-term", "pathname")
    script.setAttribute("theme", darkModeValue ? "github-dark" : "github-light")
    anchor.appendChild(script)
  }, [darkModeValue])

  return (
    <article className={`${className}`} {...props}>
      {post.featuredImage && (
        <PostEntryMedia
          imageLoading="eager"
          post={post}
          location="single"
          className={` ${
            pageTemplate === "full width"
              ? "aspect-w-3 aspect-h-1"
              : "aspect-w-16 aspect-h-9"
          }`}
        />
      )}
      <div
        className={`${
          pageTemplate === "full width" ? "center-container" : ""
        } content`}
      >
        <div className={` space-y-5 px-5 sm:px-10 pb-10`}>
          {!skipTitle && (
            <PostEntryTitle post={post} location={location} className="mb-5" />
          )}
          <PostEntryInfo post={post} className="mb-3" />
          <AdContainer />
          <PostEntryContent post={post} location={location} />
          <AdContainer />
          <div className="my-12 divider" />

          <PostEntryMeta post={post} />
          <div className="flex justify-center">
            <SocialShare
              url={normalize(`/${post.uri}`)}
              title={post.title}
              media={media}
            />
          </div>
          <PrevNextPostNavigation ctx={ctx} />
        </div>
      </div>
      <div id="inject-comments-for-uterances" />
    </article>
  )
}
